import { Model } from "pinia-orm";
import Agency from "./Agency";
import { utils } from "@socotec.io/socio-vue-components";

const SOCOTEC_GROUPS = utils.groups.SOCOTEC_GROUPS;
const DEVELOPERS_GROUPS = utils.groups.DEVELOPERS_GROUPS;
const SUPPORT_GROUPS = utils.groups.SUPPORT_GROUPS;

const MATERIAL_MANAGER_GROUP = "MaterialManager";

export default class BaseUser extends Model {
  static name = "User";

  static primaryKey = "email";

  static fields() {
    return {
      uuid: this.uid(""),
      agency: this.attr(""), // Foreign key
      cloudId: this.attr(null),
      email: this.string(""),
      firstName: this.attr(""),
      groups: this.attr([]),
      isSuperUser: this.boolean(false),
      isCurrentUser: this.boolean(false),
      jobTitle: this.string(""),
      lastName: this.attr(""),
      signature: this.attr(""),
      telephoneNumber: this.attr(""),
      lastLogin: this.string(""),
      agencyDatas: this.belongsTo(Agency, "agency"),
      socotecCode: this.string(""),
      usermanagementUuid: this.uid(""),
    };
  }

  isDev() {
    return this.isInGroups(DEVELOPERS_GROUPS);
  }

  isSupport() {
    return this.isSuperUser || this.isDev() || this.isInGroups(SUPPORT_GROUPS);
  }

  isRapsotecSupport() {
    return this.isInGroup(SOCOTEC_GROUPS.SUPPORT_RAPSOTEC);
  }

  isRapsospsSupport() {
    return this.isInGroup(SOCOTEC_GROUPS.SUPPORT_RAPSOSPS);
  }

  isTechnicalDirection() {
    return this.isInGroup(SOCOTEC_GROUPS.TECHNICAL_DIRECTION);
  }

  isNationalManager() {
    return this.isInGroup(SOCOTEC_GROUPS.NATIONAL_MANAGER);
  }

  isActivityDirector() {
    return this.isInGroup(SOCOTEC_GROUPS.ACTIVITY_DIRECTOR);
  }

  isInGroup(groupToCheck) {
    return this.groups.includes(groupToCheck);
  }

  isInGroups(groupsToCheck) {
    return this.groups.some((group) => groupsToCheck.includes(group));
  }

  isAgencyManager() {
    return this.isInGroup(SOCOTEC_GROUPS.AGENCY_MANAGER);
  }

  isAgencyGroupManager() {
    return this.isInGroup(SOCOTEC_GROUPS.AGENCY_GROUP_MANAGER);
  }

  isMaterialManager() {
    return this.isInGroup(MATERIAL_MANAGER_GROUP) || this.isDev();
  }
}
